<header></header>
<div class="post-login-2">
    <div class="post-login-2-col-1 h-100">
        <left-panel activeTab="2"></left-panel>
    </div>
    <div class="post-login-2-col-2 has-banner">
    </div>
    <div class="post-login-2-col-3 bg-base-100 p-mobile-15 h-100 pt-70-pb-70-pr-40">
        <div class="onboarding-canvas h-100">
            <grid-row class="justify-content-center align-content-between pb-30 h-100">
                <grid-col col="12">
                    <div class="font-400 font-size-20px line-h-25 color-base-700">
                        {{ "WhywouldYouwantToStop" | translate }}
                    </div>
                    <div class="font-400 font-size-14px line-h-22 color-base-500 letter-spacing-1 mt-10">
                        {{ "PleaseSelectReason" | translate }}
                    </div>
                        <div class="form-group mt-40">
                            <label>{{"Reason" | translate}}</label>
                            <drop-down-list dropDownImage="false" dropDownSearch="false" [selectedValue]="this.selectedReason"
                                [dropDownData]="this.ReasonsList" (itemselected)="Reason($event.value,$event.displayValue)">
                                {{this.selectedReason}}
                            </drop-down-list>
                        </div>
                        <!-- <grid-row class="col-space-min align-item-center">
                                                    <grid-col col="12">
                                                        <label class="no-mark">
                                                            {{ "Reason" | translate }}
                                                        </label>
                                                    </grid-col>
                                                    <grid-col col="12">
                                                
                                                        <select type="text" (change)="selectedReason($event.target.value)">
                                                            <option value="">Please select</option>
                                                            <option *ngFor="let data of this.ReasonsList" [value]="data?.strCode">{{data?.labelEn}}</option>
                                                        </select>
                                                    </grid-col>
                                                </grid-row> -->
                </grid-col>
                <grid-col col="12">
                    <grid-row class="justify-content-between align-item-center mt-50">
                        <grid-col col="auto">
                            <div class="mt-15">
                                <button class="btn-back" (click)="back()">
                                    <i class="icon-back"></i>
                                </button>
                            </div>
                        </grid-col>
                        <grid-col col="9">
                            <button class="btn-dft" [disabled]="isValid()" (click)="this.showModal(1)">
                                {{ "Next" | translate }}
                            </button>
                        </grid-col>
                    </grid-row>
                </grid-col>
            </grid-row>
        </div>
    </div>
</div>



<!-- Stop Card Modal -->

<modal modalID="1" [events]="modalObservable.asObservable()" [backdropDismiss]="true" modalDoneButtonText="CONFIRM"
    [whiteButtonStatus]="true" whiteButtonText="CANCEL" (doneButton)="UpdateCardStatus()">
    <div class="text-align-center">
        <ng-icon iconClass="icon-stop-card" width="80" height="80"></ng-icon>
        <div class="mt-40 font-400 font-size-20px line-h-25 color-base-1300">
            {{ "Stopcard" | translate }}
        </div>
        <div class="font-400 font-size-14px line-h-20 color-error p-10">
            {{ "ThisActionStopCard" | translate }}
        </div>
    </div>
</modal>

<!-- Stop Card Modal close  -->